import { Component, ViewEncapsulation, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { configuration } from 'src/app/configuration';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '../../../../../core/services/config.service';

const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'Bearer ' + sessionStorage.getItem('token'),
  }),
};

@Component({
  selector: 'app-edit-planification',
  templateUrl: './edit-planification.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
      .dark-modal .modal-content {
        background-color: #292b2c;
        color: white;
      }
      .dark-modal .close {
        color: white;
      }
      .light-blue-backdrop {
        background-color: #5cb3fd;
      }
  `]
})

export class EditPlanificationOfaComponent {
  @Input() planification;
  constructor(public activeModal: NgbActiveModal, private _loader: LoadingBarService,
              private _service: AppService, public configService: AppConfigService) { }

  editPlanification() {
    const sigle = this.configService.get('SIGLE');
    let title;
    if (sigle === 'SMB') {
      title = 'HR PERF';
    } else if (sigle === 'SIR') {
      title = 'HR PERF';
    }
    this._loader.start();
    const obj = {
      'libelle': this.planification.libelle,
      'date_debut': this.planification.date_debut,
      'date_fin': this.planification.date_fin,
      'id': this.planification.id
    };
    this._service.updateData('campagne/ofa/update', obj)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            swal.fire({
              title: title,
              type: 'success',
              text: 'La campagne ofa a été modifiée avec succès',
              showCancelButton: false,
              confirmButtonText: 'ok'
            }).then(() => {
              this.activeModal.close();
            });
          } else {
            swal.fire({
              title: title,
              type: 'warning',
              text: res.message,
              showCancelButton: false,
              confirmButtonText: 'ok'
            });
            this._loader.stop();
          }
        },
        err => {
          swal.fire({
            title: title,
            type: 'error',
            text: err,
            showCancelButton: false,
            confirmButtonText: 'ok'
          });
          this._loader.stop();
        }
      );
  }
}
